import { render, staticRenderFns } from "./settingTabOther.vue?vue&type=template&id=c31b4422"
import script from "./settingTabOther.vue?vue&type=script&lang=js"
export * from "./settingTabOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports